import { render, staticRenderFns } from "./rounder.vue?vue&type=template&id=122dcfcb&scoped=true&"
import script from "./rounder.vue?vue&type=script&lang=js&"
export * from "./rounder.vue?vue&type=script&lang=js&"
import style0 from "./rounder.vue?vue&type=style&index=0&id=122dcfcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122dcfcb",
  null
  
)

export default component.exports